import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSlide() {
  const scrollToNext = () => {
    document.getElementById('architecture')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="intro" className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-dark px-4 pt-16" data-id="element-302">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-303">
        <motion.div animate={{
        y: [0, -20, 0],
        opacity: [0.1, 0.2, 0.1]
      }} transition={{
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-1/4 left-1/4 w-64 h-64 bg-primary/20 rounded-full blur-[100px]" data-id="element-304" />
        <motion.div animate={{
        y: [0, 30, 0],
        opacity: [0.1, 0.15, 0.1]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} className="absolute bottom-1/3 right-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-[120px]" data-id="element-305" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-306">
        {/* Logo */}
        <motion.div initial={{
        scale: 0.5,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-8 md:mb-12" data-id="element-307">
          <img src="https://cdn.magicpatterns.com/uploads/5HMHaANdznDjgPVGeFEMmv/LetLois_Favicon_Square.png" alt="LetLois Logo" className="w-[120px] md:w-[160px] h-auto" data-id="element-308" />
        </motion.div>

        {/* Headline */}
        <motion.h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight tracking-tight" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} data-id="element-309">
          It's our business to put <br className="hidden md:block" data-id="element-310" />
          <span className="text-primary" data-id="element-311">eyeballs</span> on yours.
        </motion.h1>

        {/* Subheadline */}
        <motion.h2 className="text-xl md:text-2xl text-text-muted mb-12 max-w-3xl font-medium leading-relaxed" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-312">
          LetLois helps local service business owners connect with leads faster
          — and turn conversations into booked appointments.{' '}
          <span className="text-white font-semibold" data-id="element-313">
            Speed-to-lead matters.
          </span>
        </motion.h2>

        {/* CTA */}
        <motion.button onClick={() => {
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} className="bg-primary hover:bg-primary-hover text-white px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-lg shadow-primary/25 mx-auto" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.9
      }} data-id="element-314">
          Start Now
        </motion.button>
      </div>

      {/* Scroll Indicator */}
      <motion.div className="absolute bottom-8 left-0 right-0 flex justify-center cursor-pointer text-text-muted hover:text-white transition-colors" animate={{
      y: [0, 10, 0]
    }} transition={{
      duration: 2,
      repeat: Infinity
    }} onClick={scrollToNext} data-id="element-315">
        <ChevronDown size={32} data-id="element-316" />
      </motion.div>
    </section>;
}